// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__eujoN","hasPosition":"Loader_hasPosition__0O5cC","spinner":"Loader_spinner__HIz8Y","rotation":"Loader_rotation__FgqjB"};